/**
 * Microsoft Outlook icon component using official Outlook brand color
 */
import React from 'react';
import { cn } from '../../../lib/utils';

interface OutlookIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export function OutlookIcon({ className, ...props }: OutlookIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={cn('h-5 w-5', className)}
      {...props}
    >
      <path
        d="M7.88 12.04q0 .45-.11.87-.1.41-.32.74-.21.31-.53.5-.31.16-.73.16t-.74-.17-.53-.5-.32-.73-.1-.84q0-.46.1-.86.11-.41.32-.73.22-.32.54-.5.32-.18.75-.18t.73.17q.31.18.52.5.22.31.32.73.11.41.11.84zM24 12v9.38q0 .46-.33.8-.33.32-.8.32H7.13q-.46 0-.8-.33-.32-.33-.32-.8V18H1q-.41 0-.7-.3-.3-.29-.3-.7V7q0-.41.3-.7Q.58 6 1 6h6.5V2.55q0-.44.3-.75.3-.3.75-.3h12.9q.44 0 .75.3.3.31.3.75V10.85l1.24.72h.01q.1.07.18.18.07.12.07.25zm-6-8.25v3h3v-3zm0 4.5v3h3v-3zm0 4.5v1.83l3.05-1.83zm-5.25-9v3h3.75v-3zm0 4.5v3h3.75v-3zm0 4.5v2.03l2.41 1.5 1.34-.8v-2.73zM9 3.75V6h2l.13.01.12.04v-2.3zM5.98 15.98q.9 0 1.6-.3.71-.32 1.21-.86.5-.55.77-1.28.27-.74.27-1.6 0-.83-.25-1.55-.24-.71-.71-1.24t-1.15-.83q-.68-.3-1.55-.3-.92 0-1.64.3-.72.3-1.23.85-.5.54-.77 1.28-.27.73-.27 1.6 0 .84.26 1.55.26.72.74 1.24.48.52 1.17.81.69.3 1.55.3zM7.5 21h12.39L12 16.08V17q0 .41-.3.7-.29.3-.7.3H7.5z"
        fill="#0078D4"
      />
    </svg>
  );
}
